import React from "react";
import {DialogContent, List} from "@material-ui/core";
import InstructorSection from "./InstructorSection";
import {ScheduleSection} from "./ScheduleSection";
import styled from "styled-components";
import Employee from "../../../Common/Models/Employee";
import Course from "../../../Common/Models/Course";
import InformationSection from "./InformationSection";

interface CourseViewBodyProps {
    employee: Employee;
    course: Course;
    onSelectEmployee: (employee: Employee) => void;
}

const ContentList = styled(List)`
  height: auto;
  width: 100%;
  background: white;
`;

const DialogContentContainer = styled(DialogContent)`
  padding: 0px 8px;
`;

const CourseViewBody = (props: CourseViewBodyProps) => {
    const {employee, course, onSelectEmployee} = props;
    return (
        <DialogContentContainer dividers>
            <ContentList disablePadding>
                {employee?.fullName &&
                    <InstructorSection
                        employee={employee}
                        onClick={onSelectEmployee}
                    />
                }
                <InformationSection course={course} />
                <ScheduleSection
                    schedules={course?.schedule} />
            </ContentList>
        </DialogContentContainer>
    );
};

export default CourseViewBody;